 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-01e28590":"5900c76d","chunk-0471966a":"9e9a0879","chunk-06caf0de":"b055c7d1","chunk-0867d75f":"a03e21ec","chunk-09cd0b70":"32b91d53","chunk-0a1eaca9":"7ecee873","chunk-0e072455":"b209e705","chunk-0ffeab9f":"cae8fa5a","chunk-198e3942":"28734681","chunk-1f16206c":"197c9efd","chunk-1fbf062e":"5173ea61","chunk-245db3ed":"b7eac84a","chunk-268044d4":"4f4ff8d1","chunk-28a9e288":"3de847b6","chunk-29757256":"01be82d6","chunk-2a9b8bee":"2af03b76","chunk-2aed0630":"fd714dd2","chunk-2d0aa1e4":"133744c0","chunk-2d0ac931":"8e7072fb","chunk-2d0b20f8":"19dfe690","chunk-2d0b9671":"63cdf19a","chunk-2d0bdd44":"d1b6360a","chunk-2d0be327":"6dbd0aa0","chunk-2d0c0883":"07d54c79","chunk-2d0c211b":"6ea11fb7","chunk-2d0c8e41":"db1369e5","chunk-2d0c952b":"c30fc29e","chunk-2d0cf315":"c28fc18f","chunk-2d0e1b06":"b52ef7df","chunk-2d0e9079":"a8096f61","chunk-2d0f060d":"ceb56403","chunk-2d0f0814":"b82572a7","chunk-2d0f14f4":"9c78a671","chunk-2d2095dd":"e21e2cc1","chunk-2d20fcba":"bc1095d4","chunk-2d213925":"8e3dc595","chunk-2d2140aa":"fecc2f5b","chunk-2d217def":"d7551253","chunk-2d218418":"e8745151","chunk-2d21a9aa":"22d2b69e","chunk-2d21e3aa":"a4dbef43","chunk-2d222525":"ec2f2d64","chunk-2d222cca":"9bbea5a2","chunk-2d22895d":"4b390f4d","chunk-2d2304b6":"8b48da57","chunk-2d23721e":"b72b58a1","chunk-3172533a":"2635eed6","chunk-32cdbffc":"f5355a5b","chunk-36da2acc":"130dbf26","chunk-37ff8997":"e73c3e51","chunk-3b7db6f5":"9b611ea0","chunk-3bd70db3":"8c1d1c1b","chunk-407ff52c":"772fa711","chunk-41729f35":"043d1cd8","chunk-41c90a6b":"ed0ea0ab","chunk-45636d0e":"0f48f848","chunk-45df0daa":"5ac4529b","chunk-469a106c":"f9a5c9ad","chunk-4960e528":"55376341","chunk-4d93dcb2":"b53a784b","chunk-4da36b15":"20ed5a03","chunk-4f3678b7":"02bd6c2b","chunk-517be0f2":"972b025f","chunk-55fd9bc5":"8218e826","chunk-57a83ac0":"5f1e1667","chunk-5b23fdd4":"37fc3093","chunk-6435f914":"0b948308","chunk-658c23da":"14e71859","chunk-6a5dbffb":"e38aaa47","chunk-6ae2b080":"f2f4b737","chunk-6d44dfd7":"f3e92c88","chunk-6d941db0":"79ccc0e9","chunk-6da41528":"faa9d0a9","chunk-6da41684":"b795fd82","chunk-784b7358":"f4c3ab49","chunk-793ec3d8":"2bad2c33","chunk-7a234d26":"d10cf30c","chunk-7d21e4da":"1d89b749","chunk-882768b0":"1d6cb283","chunk-91f17c44":"f32e691e","chunk-972e2b1c":"da4ba0e2","chunk-9f295fda":"7d6a55cb","chunk-a92a499c":"29d84820","chunk-a92d751a":"7cda1c33","chunk-a9543e8c":"50d27cb3","chunk-a9591d90":"d2e81e86","chunk-ae124cc0":"ea4a91f6","chunk-b7bd1482":"33aaa04b","chunk-2d216db0":"7630b599","chunk-2d230100":"3cdc9148","chunk-bd819d48":"dec063f3","chunk-c377db64":"f6cc59a9","chunk-d6be8784":"97f647bd","chunk-dada39de":"e946e5a2","chunk-dd32cf7c":"57d6481a","chunk-de1eb938":"5e492ea1","chunk-dffd094a":"d70f0ef5","chunk-ea2d3954":"df16abc4","chunk-efc7162e":"612591f8","chunk-f71781cc":"f885f850","stencil-polyfills-css-shim":"5a5e7686","stencil-polyfills-dom":"f7bb9093","chunk-2d0a4d7c":"61e9449d","chunk-2d0aad2b":"2a8ea310","chunk-2d0b6574":"da8dbde2","chunk-2d0cc79b":"12d75e40","chunk-2d0da519":"b0127738","chunk-2d21ef46":"2d73d1b7","chunk-2d224c4a":"28f01afc","chunk-2d230089":"4fb12bcd","chunk-2d0bd627":"c03bf9da"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
